import React from 'react'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import styled from 'styled-components'

import { Panel } from 'components/Panel'
import Spinner from 'components/Spinner'

import { useStoreContext } from 'hooks/StoreContext'

import { color } from 'styles/colors'

type ReportsProps = {
  showSystemReports: boolean
  showVerificationReports: boolean
}

const Reports = ({ showSystemReports, showVerificationReports }: ReportsProps) => {
  const { systemReports, areSystemReportsLoaded, verificationReports, areVerificationReportsLoaded } = useStoreContext()

  const rowItem = (showRow, areItemLoaded, item, itemTitle) => {
    if (showRow) {
      return (
        <S.Row>
          <ArticleOutlinedIcon />
          <span>{itemTitle}</span>
          {areItemLoaded ? (
            <span>({item?.length || 0})</span>
          ) : (
            <Spinner variant="cell" />
          )}
        </S.Row>
      )
    }
  }

  return (
    <S.Panel>
      <Panel.Header>
        <Panel.Title>Reports</Panel.Title>
      </Panel.Header>
      {rowItem(showSystemReports, areSystemReportsLoaded, systemReports, 'System')}
      {rowItem(showVerificationReports, areVerificationReportsLoaded, verificationReports, 'Link Verification')}
    </S.Panel>
  )
}

const S = {
  Panel: styled(Panel)`
    margin: 0;
    padding: 0;
    border: none;
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    color: ${color('dashboardSecondaryText')};
    padding-bottom: 10px;
  `
}

export default Reports
